import React from "react";
import PageHeader from "@/shared/components/PageHeader";
import { Box, Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { SettlementManagementType } from "@/features/my-order/features/settlement-management/types";
import useSettlementManagementQuery from "@/features/my-order/features/settlement-management/hooks/useSettlementManagementQuery";

function SettlementManagementHeader() {
  const { tTitle } = useI18nHelper();
  const { query, setQuery } = useSettlementManagementQuery();

  const tabList: SettlementManagementType[] = ["FEE", "CREDIT"];
  // const tabList: SettlementManagementType[] = ["FEE", "CREDIT", "DEPOSIT"];

  const handleTabClick = (tab: SettlementManagementType) => {
    setQuery({
      type: tab,
    });
  };

  return (
    <>
      <PageHeader
        title={tTitle("settlement:title")}
        textStyle={"heading-sm"}
        padding={"10px 16px"}
      />
      <Flex
        paddingX={"16px"}
        background={"#FFFFFF"}
        boxShadow={"0 0.5px 0 0 #D4D4D1"}
      >
        {tabList.map((tab) => {
          const isSelected = query.type === tab;

          return (
            <Box
              key={tab}
              padding={"12px 8px"}
              cursor={"pointer"}
              boxShadow={isSelected ? "inset 0 -2px 0 0 #444444" : "none"}
              onClick={() => handleTabClick(tab)}
              position={"relative"}
              _hover={{
                "&::before": {
                  content: '""',
                  background: "#363636",
                  opacity: 0.04,
                  position: "absolute",
                  inset: 0,
                },
              }}
              _active={{
                "&::before": {
                  content: '""',
                  background: "#363636",
                  opacity: 0.12,
                  position: "absolute",
                  inset: 0,
                },
              }}
            >
              <Text
                textStyle={isSelected ? "body-lg-semi-bold" : "body-lg-medium"}
                color={isSelected ? "#444444" : "#6F6F6C"}
              >
                {tTitle(`settlement:${tab.toLowerCase()}`)}
              </Text>
            </Box>
          );
        })}
      </Flex>
    </>
  );
}

export default SettlementManagementHeader;
